import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { getProjectDetails } from "actions/projects";

export const GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_REQUEST =
  "@@evTariffUptake/GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@evTariffUptake/GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_FAILURE =
  "@@evTariffUptake/GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_FAILURE";

export function getEvTariffUptakeDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=scen_ev_tariff_uptake&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);

      dispatch({
        type: GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_EV_TARIFF_UPTAKE_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_EV_TARIFF_UPTAKE_LIST_REQUEST =
  "@@evTariffUptake/GET_EV_TARIFF_UPTAKE_LIST_REQUEST";
export const GET_EV_TARIFF_UPTAKE_LIST_SUCCESS =
  "@@evTariffUptake/GET_EV_TARIFF_UPTAKE_LIST_SUCCESS";
export const GET_EV_TARIFF_UPTAKE_LIST_FAILURE =
  "@@evTariffUptake/GET_EV_TARIFF_UPTAKE_LIST_FAILURE";

export function getEvTariffUptakeList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_EV_TARIFF_UPTAKE_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=scen_ev_tariff_uptake&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_EV_TARIFF_UPTAKE_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_EV_TARIFF_UPTAKE_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_EV_TARIFF_UPTAKE_LIST_REQUEST =
  "@@evTariffUptake/DELETE_EV_TARIFF_UPTAKE_LIST_REQUEST";
export const DELETE_EV_TARIFF_UPTAKE_LIST_SUCCESS =
  "@@evTariffUptake/DELETE_EV_TARIFF_UPTAKE_LIST_SUCCESS";
export const DELETE_EV_TARIFF_UPTAKE_LIST_FAILURE =
  "@@evTariffUptake/DELETE_EV_TARIFF_UPTAKE_LIST_FAILURE";

export function deleteEvTariffUptakeList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_EV_TARIFF_UPTAKE_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=scen_ev_tariff_uptake&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_EV_TARIFF_UPTAKE_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getProjectDetails(id));
    } catch (error) {
      dispatch({
        type: DELETE_EV_TARIFF_UPTAKE_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_EV_TARIFF_UPTAKE_DATA_REQUEST =
  "@@evTariffUptake/UPLOAD_EV_TARIFF_UPTAKE_DATA_REQUEST";
export const UPLOAD_EV_TARIFF_UPTAKE_DATA_SUCCESS =
  "@@evTariffUptake/UPLOAD_EV_TARIFF_UPTAKE_DATA_SUCCESS";
export const UPLOAD_EV_TARIFF_UPTAKE_DATA_FAILURE =
  "@@evTariffUptake/UPLOAD_EV_TARIFF_UPTAKE_DATA_FAILURE";

export function uploadEvTariffUptakeData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_EV_TARIFF_UPTAKE_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=scen_ev_tariff_uptake`;
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");
          setTimeout(() => {
            dispatch(getEvTariffUptakeList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_EV_TARIFF_UPTAKE_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_EV_TARIFF_UPTAKE_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_EV_TARIFF_UPTAKE_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
